<template>
  <div class="container">
    <div class="avatarBox">
      <span>头像</span>
      <van-image
        fit="cover"
        :src="info.Photo"
        round
        error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
      ></van-image>
    </div>
    <div class="itemBox">
      <div class="itemBlock">
        <div>
          <span class="star">*</span>
          <span>姓名</span>
        </div>
        <input placeholder="请输入您的姓名" v-model="info.ContactName" />
      </div>
      <div class="itemBlock">
        <div>
          <span style="display: none">*</span>
          <span>职位</span>
        </div>
        <input placeholder="请输入您的职位" v-model="info.Duty" />
      </div>
      <div class="itemBlock">
        <div>
          <span class="star">*</span>
          <span>邮箱</span>
        </div>
        <input placeholder="请输入邮箱" v-model="info.Email" />
      </div>
      <div class="itemBlock">
        <div>
          <span class="star">*</span>
          <span>电话</span>
        </div>
        <input placeholder="请输入电话" v-model="info.Mobile" />
      </div>
      <div class="itemBlock">
        <div>
          <span style="display: none">*</span>
          <span>微信号</span>
        </div>
        <input placeholder="请输入微信号" v-model="info.WeiXin" />
      </div>
    </div>

    <div class="itemBox">
      <div class="itemBlock">
        <div>
          <span style="display: none">*</span>
          <span>公司</span>
        </div>
        <input
          placeholder="请输入公司名称"
          v-model="info.CompanyName"
          :disabled="noEdit"
        />
      </div>
      <div class="itemBlock" v-if="info.MemberID == 0" @click.stop="openArea">
        <div>
          <span style="display: none">*</span>
          <span>地址</span>
        </div>
        <input
          placeholder="选择省市区县"
          v-model="provinceCityCounty"
          disabled
        />
      </div>
      <div v-if="info.MemberID == 0" class="itemBlock">
        <div>
          <span style="display: none">*</span>
          <span style="display: none">地址</span>
        </div>
        <input placeholder="请输入详细地址" v-model="info.Address" />
      </div>
      <div v-else class="itemBlock">
        <div>
          <span style="display: none">*</span>
          <span>地址</span>
        </div>
        <input
          placeholder="请输入详细地址"
          v-model="info.FullAddress"
          :disabled="noEdit"
        />
      </div>
    </div>

    <div class="itemBox">
      <div class="workBox">
        <span>业务范围</span>
        <textarea
          placeholder="请输入相关业务范围，不超过150个字"
          v-model="info.MainSupply"
        ></textarea>
      </div>
    </div>

    <div class="btnBox">
      <div class="deleteBtn" @click="deleteClick">删除</div>
      <div class="saveBtn" @click="saveClick">保存</div>
    </div>

    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
import { Image, Picker, Popup, Toast } from "vant";
import { getRegionList } from "@/api/member";
import {
  memberBusinessContactInfo,
  updateMemberBusinessContact,
  deleteMemberBusinessContact,
} from "@/api/index";
export default {
  name: "modifyPostcard",
  components: {
    "van-image": Image,
    Toast,
    "van-popup": Popup,
    "van-picker": Picker,
  },
  data() {
    return {
      province: "",
      city: "",
      county: "",
      provinceCityCounty: "",

      provincesIndex: 0,
      citysIndex: 0,
      countyIndex: 0,

      columns: [],
      showPicker: false,
      info: {
        ContactName: "",
        Duty: "",
        Mobile: "",
        Email: "",
        WeiXin: "",
        WeiXinQRCode: "",
        CompanyName: "",
        ProvinceName: "",
        CityName: "",
        RegionName: "",
        Address: "",
        MainSupply: "",
      },
      disabled: false,
      noEdit: false,
    };
  },
  methods: {
    //获取名片详情
    getDetail() {
      var that = this;
      var data = {
        ContactID: that.$route.query.id,
      };
      memberBusinessContactInfo(data).then((res) => {
        that.info = res.Data;
        that.provinceCityCounty =
          res.Data.ProvinceName + res.Data.CityName + res.Data.RegionName;
        if (res.Data.MemberID > 0) {
          that.noEdit = true;
        }
        that.getReginList();
      });
    },

    //打开地址
    openArea() {
      this.showPicker = !this.showPicker;
      if (this.showPicker) {
        this.getRegionList();
      }
    },

    //获取区域列表
    getRegionList() {
      getRegionList().then((res) => {
        var list = [];
        res.Data.forEach((item, index) => {
          list.push({
            text: item.Name,
          });
          list[index].children = [];
          if (this.province == item.Name) {
            this.provincesIndex = index;
            this.provincesId = item.Code;
          }
          item.Sub.forEach((sitem, sindex) => {
            list[index].children.push({
              text: sitem.Name,
            });
            list[index].children[sindex].children = [];
            if (this.city == sitem.Name) {
              this.citysIndex = sindex;
              this.cityId = sitem.Code;
            }
            sitem.Sub.forEach((pitem, pindex) => {
              list[index].children[sindex].children.push({
                text: pitem.Name,
              });
              if (this.county == pitem.Name) {
                this.countyIndex = pindex;
                this.countyId = pitem.Code;
              }
            });
          });
        });
        this.columns = list;
        this.province = this.columns[this.provincesIndex].text;
        this.city = this.columns[this.provincesIndex].children[
          this.citysIndex
        ].text;
        this.county = this.columns[this.provincesIndex].children[
          this.citysIndex
        ].children[this.countyIndex].text;
      });
    },

    //点击确认
    onConfirm(value) {
      this.provinceCityCounty = value;
      this.province = value[0];
      this.city = value[1];
      this.county = value[2];
      this.showPicker = false;
    },

    //修改名片
    saveClick() {
      var that = this;
      if (that.info.ContactName == "") {
        that.Common.showMsg("姓名不能为空");
        return false;
      }
      if (
        !/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(
          that.info.Email
        )
      ) {
        that.Common.showMsg("邮箱格式错误");
        return false;
      }
      if (that.info.Mobile == "") {
        that.Common.showMsg("电话不能为空");
        return false;
      }
      var data = {
        ContactID: that.$route.query.id,
        Duty: that.info.Duty,
        Mobile: that.info.Mobile,
        ContactName: that.info.ContactName,
        Email: that.info.Email,
        WeiXin: that.info.WeiXin,
        WeiXinQRCode: "",
        CompanyName: that.info.CompanyName,
        ProvinceName: that.province,
        CityName: that.city,
        RegionName: that.county,
        Address: that.info.Address,
        MainSupply: that.info.MainSupply,
      };
      updateMemberBusinessContact(data).then((res) => {
        that.Common.confirmDialog("确定修改名片？", function () {
          that.$router.push("/myPostcard");
        });
      });
    },

    //删除名片
    deleteClick() {
      var that = this;
      deleteMemberBusinessContact({
        ContactID: that.$route.query.id,
      }).then((res) => {
        that.Common.confirmDialog("确定删除名片？", function () {
          that.$router.replace("/myPostcard");
        });
      });
    },
  },
  mounted() {
    this.getDetail();
  },
};
</script>
<style lang="less" scoped>
.container {
  background-color: #efefef;
  padding-bottom: 120px;
}
.avatarBox {
  height: 84px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 13px;
  color: #333;
  padding: 0px 17px 0px 53px;
  .van-image {
    display: block;
    width: 50px;
    height: 50px;
  }
}
.itemBox {
  background-color: #fff;
  font-size: 13px;
  padding: 25px 0px 43px 0px;
  margin-bottom: 11px;
  .itemBlock {
    display: flex;
    justify-content: space-between;
    height: 45px;
    line-height: 45px;
    margin: 0px 17px;
    border-bottom: 1px solid #ddd;
    div {
      width: 50px;
      text-align: right;
      margin-left: 15px;
    }
    input {
      width: 260px;
      height: 38px;
      line-height: 38px;
      border: none;
      &:disabled {
        // color: #000;
        // opacity: 1;
        // -webkit-text-fill-color: #000;
        background-color: #fff;
      }
    }
    .star {
      color: #d62f2f;
      margin-right: 4px;
    }
  }
}
.workBox {
  margin-bottom: 25px;
  margin: 0px 17px;
  border-bottom: 1px solid #ddd;
  display: flex;
  justify-content: flex-start;
  span {
    margin: 2px 12px 0px 10px;
  }
  textarea {
    width: 220px;
    height: 100px !important;
    border: none;
  }
}
.btnBox {
  position: fixed;
  bottom: 20px;
  left: 58px;
  display: flex;
  align-items: center;
  div {
    width: 100px;
    height: 40px;
    line-height: 40px;
    border-radius: 20px;
    text-align: center;
    font-size: 15px;
  }
  .deleteBtn {
    margin-right: 50px;
    color: #d62f2f;
    border: 1px solid #d62f2f;
  }
  .saveBtn {
    color: #fff;
    background-color: #d62f2f;
  }
}
</style>